import { connect } from 'react-redux';

import * as actions from 'actions';
import Questionnaire from 'components/Questionnaire';

const mapStateToProps = (state, ownProps) => {
  return {
    lastUpdated: ownProps.questionnaire.updatedAt
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onQuestionAnswer: (questionnaire, question, answer, value) => {
      dispatch(actions.chatQuestionUpdate(questionnaire.id, question.id, { answer, value }));
      dispatch(actions.chatQuestionnaireUpdate(questionnaire.id, { updatedAt: new Date() }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Questionnaire);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/ChatQuestionnaire/index.js
 **/